/**
* Video Feature JS
* -----------------------------------------------------------------------------
*
* All the JS for the Video Feature component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Plyr from 'plyr';
( function( app ) {
  const COMPONENT = {

    className: 'video-feature',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const players = Array.from( $( '.plyr__video' ) ).map( ( element ) => new Plyr( element, {controls: ['play', 'progress', 'mute', 'fullscreen']} ) );
      $( '.video-feature' ).each( function( index, element ) {
        $( element ).find( '.video-player-button' ).on( 'click', function() {
          $( this ).closest( '.video-player-overlay' ).fadeOut();
          players[index].play();

          players[index].on( 'ended', ( event ) => {
            $( element ).find( '.video-player-overlay' ).fadeIn();
          } );
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'video-feature', COMPONENT );
} )( app );
